import { getHistory } from '@blocs.router';
import { getEnvironment } from '@minecraft.environment';

const getRedirectQueryParams = (
  clearStorage: boolean,
  shouldRedirectBack: boolean,
  backUrl?: string
): URLSearchParams => {
  const environment = getEnvironment();
  const searchParams = new URLSearchParams();

  if (clearStorage) {
    searchParams.append('clearLocalStorage', 'true');
  }

  if (shouldRedirectBack) {
    // in the future we want to update this and all consumers so that the query params
    // get passed in from the useRouter hook data, instead of using this history singleton
    // but for now this is easier to implement without having to refactor all the existing code that uses this util function
    const history = getHistory();
    const { location } = history;
    const audience = String(environment['AUDIENCE']).toLowerCase();
    const redirectBackUrl: string = backUrl || location.pathname;

    searchParams.append('redirectAudience', audience);

    // do not circularly redirect back to the authenticate route, b/c it will have a stale
    // refresh token embedded and cause the page to fail to load correctly
    if (!redirectBackUrl.startsWith('/authenticate')) {
      searchParams.append('redirectUrl', redirectBackUrl);
    }

    // Set search params, overriding existing is overlaps
    const originalSearchParams = new URLSearchParams(location.search);
    // don't forward the redirectToRegistration param to the login page, it's intended to be consumed here
    originalSearchParams.delete('redirectToRegistration');

    Array.from(originalSearchParams.entries()).forEach(([key, value]) => searchParams.set(key, value));
  }

  return searchParams;
};

export default getRedirectQueryParams;
